import {
  ApplicationConfig, provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import {provideRouter, withComponentInputBinding, withViewTransitions} from '@angular/router';
import {provideHttpClient, withInterceptors, withXsrfConfiguration} from '@angular/common/http';
import { routes } from './app.routes';
import {loaderInterceptor} from '@shared/lib/loader.interceptor';
import {authInterceptor} from '@shared/lib/auth.interceptor';
import {LIB_ENV} from '@library/lib/tokens/env.token';
import {env} from '@envs/environment';
import {Logger} from '@library/utils/logger';

Logger.configure(env.production);


export const appConfig: ApplicationConfig = {
  providers: [
    // provideCheckNoChangesConfig({exhaustive: true, interval: 200}), // this for check no changes development mode
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withViewTransitions(),
      withComponentInputBinding()
    ),
    provideZonelessChangeDetection(),
    provideHttpClient(
      withInterceptors([loaderInterceptor, authInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
      })
    ),
    { provide: LIB_ENV, useValue: env }
  ]
};
